import React from "react";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles((theme) => ({
  dropDown: {
    fontFamily: "Inter-Medium",
    fontSize: "1.4rem !important",
    // background: "#F2F4F7 !important",
    color: "#101828 !important",
    borderBottom: "1px solid #F2F4F7 !important",
    //  paddingBottom:"0rem",
    "& ul .MuiList-root-MuiMenu-list": {
      paddingBottom: "0rem !important",
    },
    "& .css-6hp17o-MuiList-root-MuiMenu-list": {
      maxWidth: "25% !important",
    },
  },
}));
export default function ThreeDotsMenu({ list, selectedValue, style = {} }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton aria-label="Edit" onClick={handleClick} sx={style}>
        <MoreVertOutlinedIcon
          sx={[
            {
              fontSize: "3rem !important",
              // color: "#ff0000ad !important",
            },
          ]}
        />
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={[
            {
              fontSize: "1.4rem !important",
            },
          ]}
        >
          {list.map((element, index) => (
            <MenuItem
              className={classes.dropDown}
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(null);
                selectedValue(element);
              }}
              key={index}
              value={element.value ? element.value : element}
            >
              {element.label ? element.label : element}
            </MenuItem>
          ))}
        </Menu>
      </IconButton>
    </>
  );
}
